import { render, staticRenderFns } from "./VuetifyMoney.vue?vue&type=template&id=08c37ebf"
import script from "./VuetifyMoney.vue?vue&type=script&lang=js"
export * from "./VuetifyMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports